import { Pipe, PipeTransform } from '@angular/core';
import { multiplyWithPrecision } from '@sg/common/src/lib/units-conversion-utils';

@Pipe({
  name: 'sgRatioToPercentage',
  standalone: false,
})
export class SgRatioToPercentagePipe implements PipeTransform {
  transform<T extends string | null | undefined = undefined>(
    value: number | null | undefined,
    nullValue?: T,
    decimalPlaces: number = 2
  ): number | T {
    if (value == null) {
      return nullValue as T;
    }

    return multiplyWithPrecision(value, 100, decimalPlaces)!;
  }
}
